module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANtJREFUeNpiYACC/0AAIYAAIIBAjPUwhgFIFCCA4CJwAZgmGAcggBjhpjAwODJCGR+A+AFM2XyYQf0wfQABhKwHHUyAmw5TgKwTxHH4jwMABBDMbcgK1sMNRjYGmy4QOA/15nsksfXIDupH9j487JBcOh8WUGB/4vAjCDgyoBuFbAVAgCG7ev5/wqAfWQN6AIEMeI/Ef4/FUAcmoN796I5kZGQUBFKGIAxlo4P92PwAssEAyUUGaC6AB916JP59IBZAc9p8qNh9jCjFFZ0EAwgtoNZjUQwSc0BWCwCEUw5d94Ti0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sipicon/index_phone_cancel.png
// module id = 4lJW
// module chunks = 4